import * as recall from '@otter-ai/recall-client';
import { APP_ID } from '@/constants/constant';
import type { AdditionalQueryOptions } from '@/shared/utils/queryCreators';

type QueryKey = readonly ['createSpeechUpload'];

type createSpeechUploadQueryOptions = AdditionalQueryOptions<
  recall.CreateSpeechUploadResponses[200],
  QueryKey
>;

export type createSpeechUploadQuery = {
  readonly queryKey: QueryKey;
  readonly queryFn: () => Promise<recall.CreateSpeechUploadResponses[200]>;
} & createSpeechUploadQueryOptions;

/**
 * Create a query to fetch speech upload params
 *
 * @example
 * ```
 * const { data: speechUploadParams } = useQuery(createSpeechUploadQueryCreator());
 * ```
 */
export function createSpeechUploadQueryCreator(
  userid: string,
  additionalOptions: createSpeechUploadQueryOptions = {},
): createSpeechUploadQuery {
  return {
    ...additionalOptions,
    queryKey: ['createSpeechUpload'],
    queryFn: async () => {
      const response = await recall.createSpeechUpload({
        query: {
          userid: Number(userid),
          appid: APP_ID,
        },
        throwOnError: true,
      });
      return response.data;
    },
  };
}
